import type { ReactNode } from 'react';
import type { GeneratedSet } from '../types/lotto';

type MatchRenderer = (setIndex: number) => ReactNode;

export function LottoSetList({
  sets,
  bonusName,
  renderAfterRow,
  emptyText = 'Your numbers will appear here',
  getSetLabel = (i: number) => `Set ${i + 1}`,
}: {
  sets: GeneratedSet[];
  bonusName: string;
  renderAfterRow?: MatchRenderer;
  emptyText?: string;
  getSetLabel?: (index: number) => string;
}) {
  if (!sets.length) {
    return (
      <div className="empty-state" role="status">
        {emptyText}
      </div>
    );
  }

  return (
    <div className="lotto-sets">
      {sets.map((set, setIndex) => (
        <div key={setIndex} className="lotto-set">
          <div className="set-label">{getSetLabel(setIndex)}</div>
          <div className="lotto-numbers">
            {set.regular.map((num, numIndex) => (
              <div
                key={`${setIndex}-${num}-${numIndex}`}
                className="number-ball"
                style={{ animationDelay: `${setIndex * 0.3 + numIndex * 0.1}s` }}
              >
                <span className="number-ball__digit">{num}</span>
              </div>
            ))}
            <div
              className="powerball-separator"
              style={{ animationDelay: `${setIndex * 0.3 + set.regular.length * 0.1}s` }}
            >
              +
            </div>
            <div
              className="number-ball powerball"
              data-bonus-name={bonusName}
              style={{ animationDelay: `${setIndex * 0.3 + (set.regular.length + 1) * 0.1}s` }}
            >
              <span className="number-ball__digit">{set.powerball}</span>
            </div>
          </div>
          {renderAfterRow?.(setIndex)}
        </div>
      ))}
    </div>
  );
}
